import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import * as FileSaver from 'file-saver';
import autoTable from 'jspdf-autotable'
import { first } from 'rxjs/operators';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';
import { Store } from 'src/app/shared/models/Store';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { DatePipe } from '@angular/common';
import { Constants } from 'src/app/shared/vo/Constants';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';

@Component({
  selector: 'app-workshop-mng',
  templateUrl: './workshop-mng.component.html',
  styleUrls: ['./workshop-mng.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class WorkshopMngComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;
  listStore: Store[];
  selectedStore: Store;
  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO = {};

  /** WORKSHOP MNG */
  workshopMngList: any[];
  workshopMngSelected: any;
  blocked: boolean = true;
  responseFile?: ResponseFile;


  /** WORKSHOP LGC */
  workshopLgcList: any[];
  workshopLgcSelected: any;
  dataParent: any;


  yearActual: number;

  /** STATUS MODAL */
  displayModalStatus: boolean;
  statusList: ValuesVO[]
  statusSelected: ValuesVO;
  dateSelected: string;
  commentsSelected: string;


  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_church_name: string = "church_name_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "participants_last_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_1a_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lbl_period: string = "period_";
  lbl_coordination_guide_list: string = "coordination_guide_list_";
  lbl_ongoing: string = "ongoing_";
  lbl_services: string = "services_";
  lbl_total: string = "total_";
  lbl_type: string = "type_";
  lbl_language: string = "language_";
  lbl_approve: string = "approve_";
  lbl_semester: string = "semester_";
  lbl_starting_date: string = "starting_date_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";



  lstCols: { field: string; header: any; }[];



  /**
   * This is a constructor function that initializes various services and checks for data passed through
   * navigation, redirecting if none is found.
   * @param {MessageService} messageService - A service that provides methods for displaying messages to
   * the user, such as success or error messages.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service provided
   * by the PrimeNG library that allows for displaying confirmation dialogs to the user. It can be used
   * to confirm actions before they are executed, such as deleting a record or submitting a form.
   * @param {ApiService} apiService - An instance of the ApiService class, which is likely used to make
   * HTTP requests to an API.
   * @param {Router} router - The router is a service provided by Angular that allows navigation between
   * different components and views in a single-page application. It is used to navigate to different
   * routes and pass data between them. In this constructor, the router is injected as a dependency and
   * is used to get the current navigation and extract any state data
   * @param {AuthenticationService} authenticationService - This parameter is likely a service that
   * handles user authentication and authorization. It may contain methods for logging in, logging out,
   * and checking user roles and permissions.
   * @param {TovpilUtilsService} tovpilUtils - tovpilUtils is a service that provides utility functions
   * for the TOVPIL application. It is likely used to perform common tasks such as formatting data,
   * validating input, or handling errors.
   */
  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private tovpilUtils: TovpilUtilsService,
    private filesService: TovpilFilesService) {
    this.initConfigs();
    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        //this.storeId = params.storeId;
        this.selectedPeriod.year = params.year;
        this.selectedPeriod.period = params.period;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function initializes component properties and retrieves security information.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }


  /**
   * This function retrieves security information and loads participants.
   */
  getSecurity() {

    if (!this.security) {

      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {

          this.security = data;
          this.getValidPeriods();
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
  }



  /**
   * This function loads participants for a specific workshop using an API service.
   */
  loadWorkShopMng() {
    this.blocked = true;
    let params = {
      storeId: this.selectedStore ? this.selectedStore.storeId : this.storeId,
      year: this.selectedPeriod.year,
      period: this.selectedPeriod.period
    }
    this.workshopMngList = [];
    this.apiService.listWorkShopsByStoreId(params).then(
      data => {
        this.workshopMngList = this.filterWorkshopAccepted(data);

      }).catch(error => {
        console.error(error);
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });

    this.apiService.listWorkShopsByStoreId(params).then(
      data => {
        this.workshopLgcList = (data);
        this.workshopLgcList = this.workshopLgcList.filter(s => s.guiScr.status === 'A');

      }).catch(error => {
        console.error(error);
      });
  }

  filterWorkshopAccepted(data: any[]) {
    const filteredList = data.filter((item) => {
      return item.f0 && item?.f0?.status !== "X" && item?.f0?.serTyp !== "16" && item?.f0?.serTyp !== "17" && item?.f0?.serTyp !== "18";
    });
    return filteredList;
  }
  /**
   * The function retrieves translations for a list of labels and updates their values in the component.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_church_name, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data, this.lbl_period, this.lbl_ongoing, this.lbl_coordination_guide_list, this.lbl_services, this.lbl_type, this.lbl_total, this.lbl_language, this.lbl_approve, this.lbl_semester, this.lbl_starting_date, this.lbl_showing, this.lbl_of, this.lbl_records]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_church_name = map.get(this.lbl_church_name);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_period = map.get(this.lbl_period);
        this.lbl_coordination_guide_list = map.get(this.lbl_coordination_guide_list);
        this.lbl_ongoing = map.get(this.lbl_ongoing);
        this.lbl_services = map.get(this.lbl_services);
        this.lbl_type = map.get(this.lbl_type);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_approve = map.get(this.lbl_approve);
        this.lbl_semester = map.get(this.lbl_semester);
        this.lbl_starting_date = map.get(this.lbl_starting_date);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);

        this.getLstCols();
        this.getLstColsLgc();
      });
    this.loadData(this.security);
  }


  exportExcelMng() {
    this.blocked = true;
    if (this.workshopMngList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
      this.blocked = false;
    } else if (this.workshopMngList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
      this.blocked = false;
    } else {
      const params =  {
        "storeId": this.selectedStore ? this.selectedStore.storeId : this.storeId,
        "year": this.selectedPeriod.year,
        "period": this.selectedPeriod.period,
        "language": this.security.language,
      }

      // const filteredJSON = this.workshopMngList.map((item) => ({
      //   "TIPO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
      //   "NOMBRE": ((item.gui && item.gui.guiType && item.gui.name && item.gui.lastName) ? `${item.gui.guiType} ${item.gui.name} ${item.gui.lastName}` : 'S/N'),
      //   "ESTATUS": item.wrkStatName || 'S/N',
      //   "PARROQUIA": item.chr ? (item.chr.name || 'S/N') : 'S/N',
      //   "FECHA_DE_INICIO": item.f0 ? (this.formatDate(item.f0.strDate) || 'S/N') : 'S/N',
      //   "N°PARTICIPANTES_1A_(+PART.2A)": item.f0 ? (item.f0.partN2s || '0') : '0',
      //   "N°PARTICIPANTES_DESIERTO": item.f0 ? (item.f0.partN15s || '0') : '0',
      // }));
      // this.filesService.tovpilExportXLSX(filteredJSON, 'listServicesMNG_');
      try {
        this.apiService.dwdWorkshopsXls(params).then(
          data => {
            this.responseFile = data;
            const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
            const link = document.createElement("a");
            link.href = source;
            link.download = this.responseFile.nameFile
            link.click();
            this.blocked = false;
          });
      } catch (error) {
        console.error("An error occurred while getting translated labels:", error);
        this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: `});
        this.blocked = false;
      }
    }
  }

  exportPdfMng() {
    if (this.workshopMngList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.workshopMngList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.workshopMngList.map((item) => ({
        "TIPO": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
        "NOMBRE": ((item.gui && item.gui.guiType && item.gui.name && item.gui.lastName) ? `${item.gui.guiType} ${item.gui.name} ${item.gui.lastName}` : 'S/N'),
        "ESTATUS": item.wrkStatName || 'S/N',
        "PARROQUIA": item.chr ? (item.chr.name || 'S/N') : 'S/N',
        "FECHA_DE_INICIO": item.f0 ? (this.formatDate(item.f0.strDate) || 'S/N') : 'S/N',
        "N°PARTICIPANTES_1A_(+PART.2A)": item.f0 ? (item.f0.partN2s || '0') : '0',
        "N°PARTICIPANTES_DESIERTO": item.f0 ? (item.f0.partN15s || '0') : '0',
      }));

      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listServicesMNG_');

    }
  }


  exportExcelLgc() {
    if (this.workshopLgcList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.workshopLgcList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.workshopLgcList.map((item) => ({
        "ID_GUÍA": item.gui ? (item.gui.guideId || 'S/N') : 'S/N',
        "TIPO": item.guiScr ? (item.guiScr.guiType || 'S/N') : 'S/N',
        "NOMBRE": item.gui ? (item.gui.name || 'S/N') : 'S/N',
        "SERVICIOS": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
        "ESTATUS": item.wrkStatName || 'S/N'
      }));


      this.filesService.tovpilExportXLSX(filteredJSON, 'listServicesLGC_');

    }
  }

  exportPdfLgc() {
    if (this.workshopLgcList === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.workshopLgcList.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.workshopLgcList.map((item) => ({
        "ID_GUÍA": item.gui ? (item.gui.guideId || 'S/N') : 'S/N',
        "TIPO": item.guiScr ? (item.guiScr.guiType || 'S/N') : 'S/N',
        "NOMBRE": item.gui ? (item.gui.name || 'S/N') : 'S/N',
        "SERVICIOS": item.wst ? (item.wst.wsName || 'S/N') : 'S/N',
        "ESTATUS": item.wrkStatName || 'S/N'
      }));



      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));

      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'listServicesLGC_');

    }
  }

  datePipe: DatePipe = new DatePipe('en-US');
  /**
     * This function formats a given date string into a specific format using the datePipe module in
     * TypeScript.
     * @param {string} dateString - A string representing a date in any valid format (e.g. "2021-10-15" or
     * "Oct 15, 2021").
     * @returns The function `formatDate` is returning a formatted date string in the format of
     * 'dd-MM-yyyy'. The input parameter `dateString` is being passed to the `datePipe.transform` method to
     * format the date. The formatted date string is then returned by the function.
     */
  formatDate(dateString: string) {

    const formattedDate = this.datePipe.transform(this.tovpilUtils.convertStringToDate(dateString), 'yyyy-MM-dd');
    return formattedDate;
  }

  /**
 * The function "goBack" closes the current window.
 */
  goBack() {
    try {
      let navigationExtras: NavigationExtras = {
        state: JSON.parse(JSON.stringify({
          selStore: Constants.selStore,
          itemsNavigation: Constants.itemsNavigation,
          module: 'secretary',
          view: 'wrkshopMngComponent',
          forLevelId: 'L'
        }))
      };

      Constants.selStore = null;
      Constants.itemsNavigation = null;
      try {
        this.router.navigate(['/commons/lcSelector'], navigationExtras);

      } catch (navigationError) {
        console.error("An error occurred while navigating to coordination catalog details:", navigationError);
        this.handleError('Redirigir', 'Algo salio mal al redirigir a CX4');
      }
    } catch (parseError) {
      console.error("An error occurred while parsing state to JSON:", parseError);
      this.handleError('Redirigir', 'Algo salio mal al redirigir');
    }
  }

  loadData(dataSecurity: any) {
    if (dataSecurity != null) {
      this.yearActual = new Date().getFullYear();
    }
  }

  createNewWorkshopMng() {
    this.editWorkshopMng(null);

  }

  editWorkshopMng(workSel: any) {
    let obj = {
      workshop: workSel,
      security: this.security,
      type: 'WM',
      storeIdParam: this.selectedStore.storeId,
      selectedPeriod: this.selectedPeriod
    }

    let queryParamsDetail = {}

    if (this.token && this.device) {

      queryParamsDetail = {
        token: this.token,
        device: this.device
      }
    }

    let navigationExtras: NavigationExtras = {
      queryParams: queryParamsDetail,
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(
      ['/guide/workshopsDetail'], navigationExtras);
  }
  openWorkShopApprove(workshopSel: any) {

    let wrks: any;

    this.apiService.findWorkShopsDetailByID({
      wrksId: workshopSel.f0.wrksId
    }).then(
      data => {
        wrks = data;


        let obj = {
          workshop: wrks,
          security: this.security,
          type: 'WM',
          reqApprove: 'true',
          storeIdParam: this.selectedStore.storeId,
          selectedPeriod: this.selectedPeriod
        }

        let queryParamsDetail = {}

        if (this.token && this.device) {

          queryParamsDetail = {
            token: this.token,
            device: this.device
          }
        }

        let navigationExtras: NavigationExtras = {
          queryParams: queryParamsDetail,
          state: JSON.parse(JSON.stringify(obj))
        }

        this.router.navigate(
          ['/guide/workshopsDetail'], navigationExtras);

      }
    );
  }


  convertToTimeFormat(num: number): string {
    const hours = Math.floor(num / 100);
    const minutes = num % 100;
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    return `${formattedHours}:${formattedMinutes}`;
  }

  showDialogStatus(workshopSelected: any) {
    this.statusSelected = null;
    this.commentsSelected = null;
    this.dateSelected = this.tovpilUtils.dateToTovpilDateFormat(new Date());
    this.workshopMngSelected = workshopSelected;
    this.getStatusTransitionRules();
    this.displayModalStatus = true;
  }

  getStatusTransitionRules() {

    this.apiService.getStatusTransitionRules({
      "language": this.security.language,
      "fieldId": "plwStsReas",
      "fieldVal": this.workshopMngSelected.f0.status
    }).then(
      data => {
        this.statusList = data;
      });

  }

  /**
 * The function sets the values of an array of objects representing columns for a table.
 */
  getLstCols() {
    this.lstCols = [
      { field: 'gui.name', header: "" },
      { field: 'wst.wsName', header: "" },
      { field: 'f0.language', header: "" },
      { field: 'chr.name', header: "" },
      { field: 'f0.partN2s', header: "" },
      { field: 'f0.partN15s', header: "" },
      { field: 'f0.strDate', header: "" },
      { field: 'f0.endDate', header: "" },
    ];
  }

  /**
* The function sets the values of an array of objects representing columns for a table.
*/

  getLstColsLgc() {
    this.lstCols = [
      { field: 'gui.guideId', header: "" },
      { field: 'guiScr.guiType', header: "" },
      { field: 'gui.name', header: "" },
      { field: 'wst.wsName', header: "" },
      { field: 'f0.status', header: "" },
    ];
  }


  listDependetLocalStores() {
    // if (this.security.levelId == Constants.LOCAL_LEVELID) {
    //  this.listDependetGuideStores();
    //} else {
    const body = {
      storeId: Constants.selStore.storeId,
      period: this.selectedPeriod != null ? this.selectedPeriod.period : "",
      year: this.selectedPeriod != null ? this.selectedPeriod.year : ""
    };
    this.listStore = [];
    this.apiService.listDependetLocalStores(body).then(
      data => {
        this.listStore = data;
        if (this.listStore) {

          if (this.storeId) {
            this.selectedStore = this.listStore.find(s => s.storeId === this.storeId);
          }
          if (!this.selectedStore) {
            this.selectedStore = this.listStore[0];
          }
        }
        this.loadWorkShopMng();

      });
    //}
  }

 // listDependetGuideStores() {
 //   console.log(this.security.guideId);
 //   const body = {
 //     guideId: this.security.guideId

  //  };
  //  this.listStore = [];
  //  this.apiService.listDependetGuideStores(body).then(
  //    data => {
   //     this.listStore = data;
   //     if (this.listStore) {

   //       if (this.storeId) {
    //        this.selectedStore = this.listStore.find(s => s.storeId === this.storeId);
    //      }
   //       if (!this.selectedStore) {
   //         this.selectedStore = this.listStore[0];
   //       }
   //     }
   //     this.loadWorkShopMng();

    //  });
 // }

  getValidPeriods() {
    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;
        if (this.selectedPeriod && this.selectedPeriod.year) {
          this.selectedPeriod = this.listPeriods.find(s => s.year === this.selectedPeriod.year && s.period === this.selectedPeriod.period);
        } else {
          this.selectedPeriod = this.listPeriods[0];
        }
        this.listDependetLocalStores();
      });
  }
  updateStatusWorkshopMng() {

    this.apiService.changeWrksStatus({
      "language": this.security.language,
      "wrksId": this.workshopMngSelected.f0.wrksId,
      "status": this.statusSelected.valueId,
      "currDate": this.tovpilUtils.dateToTovpilDate2(this.dateSelected),
      "comments": this.commentsSelected,
      "userId": this.security.userId
    }).then(
      data => {

        if (data.status == 'OK') {
          this.loadWorkShopMng();
          this.displayModalStatus = false;
          this.messageService.add({
            severity: 'success', summary: this.lbl_updated_data, detail: '', life: 3000
          });


        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: data.errorMessage, life: 9000 });
        }

      }).catch(error => {
        console.error(error);
        this.messageService.add({ severity: 'error', summary: 'changeWrksStatus' + error + "/", detail: "Error " + error + "/", life: 3000 });
      });
  }
  initConfigs() {
    const navigation = this.router.getCurrentNavigation();
    this.dataParent = navigation?.extras?.state || {};

    if (this.dataParent) {
      const { security, selStore, selPeriod } = this.dataParent;


    }

    if (!Constants.selStore) {
      this.selectedStore = Constants.selStore;
      this.storeId = Constants.selStore.storeId;
    }
  }
  private handleError(summary: string, detail: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: summary,
      detail: detail,
      life: 5000
    });
  }

}
